import { PizzaMenu } from './components/PizzaMenu';

export { PizzaMenu };
